(function (root) {
  'use strict';
  if (!root || root.BCCartAddTrackingInstalled || !root.BCCartRecovery) return;
  const mode = root.BCCartRecoveryTrackingMode;
  if (mode !== 'shadow' && mode !== 'canonical' && mode !== 'canonical-review') return;
  root.BCCartAddTrackingInstalled = true;
  const originalFetch = root.fetch;
  const originalOpen = root.XMLHttpRequest.prototype.open, originalSend = root.XMLHttpRequest.prototype.send;
  const requests = new WeakMap(), seen = new Set(), active = new Set();
  let sequence = 0, latestSequence = 0, latestCart = null, pending = Promise.resolve(), fetchDepth = 0;
  function snapshot(cart) {
    if (!cart || !Array.isArray(cart.items) || cart.items.some(line => !line ||
      !Number.isSafeInteger(line.variant_id) || line.variant_id <= 0 ||
      !Number.isSafeInteger(line.quantity) || line.quantity <= 0)) return null;
    return { currency: cart.currency, items: cart.items.map(line => Object.assign({}, line)) };
  }
  latestCart = snapshot({ items: root.BCCartRecoveryInitialCart });
  function cache(cart, order) {
    const copy = snapshot(cart);
    if (copy && order >= latestSequence) { latestCart = copy; latestSequence = order; }
  }
  function loadPrivacy() {
    if (root.Shopify && !root.Shopify.customerPrivacy && typeof root.Shopify.loadFeatures === 'function') {
      root.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
    }
  }
  if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', loadPrivacy, { once: true });
  else loadPrivacy();
  function route(method, value) {
    try {
      const url = new URL(value, root.location.origin);
      if (url.origin !== root.location.origin) return '';
      const path = url.pathname.replace(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?/i, '/');
      if (String(method).toUpperCase() === 'GET' && /^\/cart\.(?:js|json)$/.test(path)) return 'read';
      if (String(method).toUpperCase() !== 'POST') return '';
      if (/^\/cart\/add(?:\.js)?\/?$/.test(path)) return 'add';
      if (/^\/cart\/change(?:\.js)?\/?$/.test(path)) return 'change';
      return '';
    } catch (_) { return ''; }
  }
  function restoring() { return root.BCCartRecoveryRestoring || root.location.hash.startsWith('#bc-restore='); }
  function allowed() {
    const privacy = root.Shopify && root.Shopify.customerPrivacy;
    return privacy && typeof privacy.analyticsProcessingAllowed === 'function' &&
      typeof privacy.marketingAllowed === 'function' && privacy.analyticsProcessingAllowed() && privacy.marketingAllowed();
  }
  function bodyFields(body) {
    try {
      if (typeof body === 'string') {
        try { return JSON.parse(body); } catch (_) { return Object.fromEntries(new URLSearchParams(body)); }
      }
      if (body && typeof body.entries === 'function') return Object.fromEntries(body.entries());
    } catch (_) { /* An unreadable change request cannot prove an addition. */ }
    return null;
  }
  function start(kind, body) {
    const request = { kind: kind, order: ++sequence, before: latestCart, fields: bodyFields(body), recovery: Boolean(restoring()) };
    if (kind !== 'read') {
      if (active.size) { request.ambiguous = true; active.forEach(other => { other.ambiguous = true; }); }
      active.add(request);
    }
    return request;
  }
  function ordinary(line) {
    return line && line.price !== 0 && line.final_price !== 0 && !line.gift_card &&
      !/free[ _-]?gift|shipping[ _-]?protection|insurance/i.test([line.product_type, line.product_title, line.title].join(' '));
  }
  function changedItem(request, cart) {
    if (!request.before || !request.fields || request.ambiguous) return null;
    const fields = request.fields, quantity = Number(fields.quantity), before = request.before.items;
    if (!Number.isSafeInteger(quantity) || quantity <= 0) return null;
    let prior;
    if (fields.id != null) {
      const matches = before.filter(line => line.key === String(fields.id) || line.variant_id === Number(fields.id));
      if (matches.length === 1) prior = matches[0];
    } else if (Number.isSafeInteger(Number(fields.line)) && Number(fields.line) > 0) prior = before[Number(fields.line) - 1];
    if (!prior || quantity <= prior.quantity) return null;
    const matches = cart.items.filter(line => prior.key ? line.key === prior.key : line.variant_id === prior.variant_id);
    const current = matches.length === 1 && matches[0];
    if (!ordinary(current) || current.quantity !== quantity) return null;
    return Object.assign({}, current, { quantity: current.quantity - prior.quantity });
  }
  function publish(item, cart, requestID, source) {
    pending = pending.then(async function () {
      const locale = root.Shopify && root.Shopify.routes && root.Shopify.routes.root || '/';
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(locale)) return;
      if (!cart) {
        try {
          const readOrder = ++sequence;
          const response = await originalFetch.call(root, locale + 'cart.js', {
            credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
          });
          if (response.ok) { cart = await response.json(); cache(cart, readOrder); }
        } catch (_) { /* No complete snapshot means no recovery URL. */ }
      }
      const current = cart && Array.isArray(cart.items) && cart.items.find(line =>
        item.key ? line.key === item.key : line.variant_id === (item.variant_id || item.id));
      const fields = root.BCCartRecovery.normalize(current || item, cart && cart.items, {
        origin: root.location.origin, localeRoot: locale,
        currency: cart && cart.currency || root.Shopify && root.Shopify.currency && root.Shopify.currency.active
      });
      const payload = {};
      ['product_id', 'variant_id', 'quantity', 'product_title', 'title', 'url', 'image', 'price', 'presentment_price'].forEach(key => {
        if (item[key] != null) payload[key] = item[key];
      });
      Object.assign(payload, fields, { CartRecoverySource: 'successful_cart_add' });
      if (mode === 'shadow') {
        const log = root.BCCartRecoverySuccessfulAdds = root.BCCartRecoverySuccessfulAdds || [];
        log.push({ source: source, requestID: requestID || null, consentAllowed: Boolean(allowed()), payload: payload });
        if (log.length > 20) log.shift();
      } else if (root.BCCartRecoveryLegacyReplaced && root.mu_disable_klaviyo_tracking === true && allowed() &&
          root._learnq && typeof root._learnq.push === 'function') {
        if (mode === 'canonical-review') {
          const log = root.BCCartRecoveryCanonicalPreview = root.BCCartRecoveryCanonicalPreview || [];
          log.push({ source: source, requestID: requestID || null, metric: 'Added to Cart', payload: payload });
          if (log.length > 20) log.shift();
        } else root._learnq.push(['track', 'Added to Cart', payload]);
      }
    }).catch(function () { /* Tracking must never break cart behavior. */ });
  }
  function finish(request, data, requestID, source) {
    active.delete(request);
    if (!data || data.status) return;
    if (request.kind === 'read') { cache(data, request.order); return; }
    const cart = snapshot(data);
    if (cart && request.kind === 'change') cache(cart, request.order);
    if (request.recovery || restoring() || (requestID && seen.has(requestID))) return;
    if (requestID) { seen.add(requestID); if (seen.size > 200) seen.delete(seen.values().next().value); }
    const item = request.kind === 'change' ? cart && changedItem(request, cart) :
      (Array.isArray(data.items) ? data.items : [data]).find(line => ordinary(line) && Number.isSafeInteger(line.variant_id || line.id));
    if (item) publish(item, request.kind === 'change' ? cart : null, requestID, source + '-' + request.kind);
  }
  root.fetch = function (input, init) {
    const method = init && init.method || input && input.method || 'GET';
    const url = typeof input === 'string' || input instanceof URL ? String(input) : input && input.url;
    const kind = route(method, url), request = kind && start(kind, init && init.body);
    let result;
    fetchDepth++;
    try { result = originalFetch.apply(this, arguments); } catch (error) { active.delete(request); throw error; }
    finally { fetchDepth--; }
    if (request) result.then(function (response) {
      if (!response.ok) { active.delete(request); return; }
      response.clone().json().then(data => finish(request, data, response.headers.get('x-request-id'), 'fetch'))
        .catch(() => active.delete(request));
    }, () => active.delete(request));
    return result;
  };
  root.XMLHttpRequest.prototype.open = function (method, url) {
    const previous = requests.get(this);
    if (previous && previous.onLoad) this.removeEventListener('load', previous.onLoad);
    if (previous && previous.request) active.delete(previous.request);
    requests.set(this, { kind: route(method, url), done: false });
    return originalOpen.apply(this, arguments);
  };
  root.XMLHttpRequest.prototype.send = function (body) {
    const entry = requests.get(this);
    if (entry && entry.kind && !fetchDepth) {
      entry.request = start(entry.kind, body);
      entry.onLoad = function () {
        if (entry.done) return;
        entry.done = true;
        if (this.status < 200 || this.status >= 300) { active.delete(entry.request); return; }
        try { finish(entry.request, this.responseType === 'json' ? this.response : JSON.parse(this.responseText), this.getResponseHeader('x-request-id'), 'xhr'); }
        catch (_) { active.delete(entry.request); }
      };
      this.addEventListener('load', entry.onLoad, { once: true });
      ['abort', 'error', 'timeout'].forEach(type => this.addEventListener(type, () => active.delete(entry.request), { once: true }));
    }
    try { return originalSend.apply(this, arguments); } catch (error) { if (entry) active.delete(entry.request); throw error; }
  };
})(typeof window === 'undefined' ? null : window);
